import { differenceInYears } from "date-fns";
import { PatientAgeAlertType } from "../../Patient/PatientAgeAlert";

export interface CheckIsMinAgeValidParams {
  dateBirth?: string | null;
  minOnlineBookingAge: number;
  minSelfBookingAge: number;
  isLegalGuardian: boolean;
  isCenterUser: boolean;
}

type CheckIsMinAgeValidResult =
  | { isValid: true }
  | { isValid: false; errorType?: PatientAgeAlertType };

const checkIsMinAgeValid = (
  params: CheckIsMinAgeValidParams,
): CheckIsMinAgeValidResult => {
  const {
    minOnlineBookingAge,
    minSelfBookingAge,
    dateBirth,
    isLegalGuardian,
    isCenterUser,
  } = params;

  if (isCenterUser) {
    return { isValid: true };
  }

  if (!dateBirth) {
    return { isValid: false };
  }

  const age = differenceInYears(new Date(), new Date(dateBirth));

  if (age < minOnlineBookingAge) {
    return { isValid: false, errorType: "online_booking" };
  }

  if (!isLegalGuardian && age < minSelfBookingAge) {
    return { isValid: false, errorType: "self_booking" };
  }

  return { isValid: true };
};

export default checkIsMinAgeValid;
